import { ThemeProvider } from '@mui/material/styles';
import { useGetTenant } from '@reactQuery/tenant';
import { ITenantProvider } from './interfaces';
import { createTenantTheme } from '@themes/createTenantTheme';
import { createContext, useContext, useEffect } from 'react';
import { Tenant } from '@api/tenantApi/interfaces';
import { applyBranding } from './helpers';

export const TenantContext = createContext<Tenant | null>(null);

export const TenantProvider: React.FC<ITenantProvider> = ({ children }) => {
  const { data: tenant, isLoading } = useGetTenant();

  useEffect(() => {
    if (tenant?.name) {
      document.title = tenant.name;
    }
  }, [tenant]);

  if (isLoading || !tenant) {
    return null;
  }

  const theme = createTenantTheme(tenant.theme);

  applyBranding(tenant.theme);

  return (
    <TenantContext.Provider value={tenant}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
